import { Component } from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import { AQH_EVE_0 } from "../../../../../../@shared/models/input.module";
import {EventResponse} from '../../../../../../@shared/models/response.module';
import {EventsService} from '../../../../../../@shared/services/events-service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {UpdateEventImage} from './components/update-event-image/update-event-image';

@Component({
  selector: 'app-manage-event',
  standalone: false,
  templateUrl: './manage-event.html',
  styleUrl: './manage-event.css'
})
export class ManageEvent {
  eventId: string
  event: EventResponse
  selectedTab: string = 'overview'

  constructor(private route: ActivatedRoute,
              private eventService: EventsService,
              private modalService: NgbModal) {
  }

  ngOnInit() {
    this.eventId = String(this.route.snapshot.paramMap.get('id'));
    this.getEvent()
  }

  getEvent() {
    let params: AQH_EVE_0 = {
      event_id: Number(this.eventId)
    }
    this.eventService.getEvents(params).subscribe((res) => {
      this.event = res.data[0];
      console.log("Mange event: ", this.event)
    })

  }

  openEditImageModal(imageType: 'header' | 'logo') {
    let modalRef = this.modalService.open(UpdateEventImage, {centered: true, size: 'md'});
    modalRef.componentInstance.event = this.event;
    modalRef.componentInstance.imageType = imageType;
    modalRef.result.then((result) => {
      if (result) {
        this.getEvent();
      }
    }).catch(() => {});
  }

}
